<div class="card-files" *ngIf="uploadedFiles.length > 0">
  <div class="card-title-files">
    <h3 class="uploaded-files-title" *ngIf="uploadedFiles.length > 0">
      {{ "nouns.uploaded-files-title" | translate }}
    </h3>
  </div>

  <div class="uploaded-files-wrapper" *ngIf="uploadedFiles.length > 0">
    <div class="uploaded-file-card" *ngFor="let file of uploadedFiles">
      <div class="file-top-row">
        <div class="file-left">
          <lib-icon type="document" size="md" class="file-icon"></lib-icon>
          <div>
            <div class="file-name" [title]="file.name">{{ file.name }}</div>
            <div class="file-size">{{ file.size }} {{ "nouns.file-size-unit" | translate }}</div>
          </div>
        </div>
        <div class="file-right">
          <lib-icon *ngIf="file.progress === 100" type="checkCircle" class="file-status-icon success"></lib-icon>
          <button type="button" class="file-delete-button" (click)="onDeleteFile(file)">
            <lib-icon type="trash" size="sm"></lib-icon>
          </button>
        </div>
      </div>

      <div class="file-progress-row">
        <div class="file-progress-bar">
          <div class="file-progress-fill" [style.width.%]="file.progress"></div>
        </div>
        <div class="file-progress-percent">{{ file.progress }}%</div>
      </div>
    </div>
  </div>
</div>

<div class="upload-container">
  <button libButton size="m" (click)="onSelectFile()">
    {{ "nouns.select-device-file" | translate }}
  </button>
</div>

<div class="upload-actions" *ngIf="uploadedFiles.length > 0">
  <button libButton appearance="primary" size="m" [disabled]="isLoading" (click)="onUpload()">
    {{ "actions.upload-document" | translate }}
  </button>
  <button libButton appearance="outline" size="m" (click)="onCancel()">
    {{ "actions.cancel" | translate }}
  </button>
</div>
